import React, { useRef } from 'react';
import { Select } from 'antd';
import { BaseSelectRef } from 'rc-select';
import { UserIPMap } from '../../models/userIP';

const { Option } = Select;

interface UserIPSelectProps {
    onSelect?: (value: string) => void;
    value?: string;
    onChange?: (value: string) => void;
}

const UserIPSelect: React.FC<UserIPSelectProps> = props => {
    const { onSelect, value, onChange } = props;

    const selectEl = useRef<BaseSelectRef>(null);

    const onUserIPSelect = (e: string) => {
        selectEl.current!.blur();
        if (onSelect) {
            onSelect(e);
        }
    };

    const renderOption = (item: string, index: number) => (
        <Option
            key={item}
            value={index}
        >
            {item}
        </Option>
    );

    return (
        <Select
            value={value}
            defaultValue={undefined}
            ref={selectEl}
            style={{ width: 120 }}
            optionFilterProp="children"
            placeholder="Select User IP"
            onSelect={onUserIPSelect}
            onChange={onChange}
            allowClear
        >
            {[...Object.values(UserIPMap)].map(renderOption)}
        </Select>
    );
};

export default UserIPSelect;
